export default `
uniform sampler2D uMatcap;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform vec3 uColor4;
uniform vec3 uLightColor;
uniform float uTime;
uniform vec3 uRandom;
uniform vec3 uBgColor;
uniform vec4 uColorMap;
uniform vec3 uLightPos;
uniform float uLightIntensity;
uniform vec2 uBgRange;
uniform vec4 uProgress;

varying vec3 vNormal;
varying vec3 vViewPosition;
varying vec3 vPosition;
varying vec3 vWorldPos;

float fresnelEffect(float power){
  return pow((1.0 - clamp(dot(normalize(vNormal), normalize(-vViewPosition)), 0.0, 1.0)), power);
}

mat2 rotate2D(float r){
  float c = cos(r);
  float s = sin(r);
  return mat2(c, s, -s, c);
}

void main(){
  float light = smoothstep(0.0, 0.8, dot(normalize(vNormal), normalize(uLightPos - vWorldPos)));
  vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, -viewDir.x ) );
	vec3 y = cross( viewDir, x );

	vec2 uv = vec2( dot( x, vNormal ), dot( y, vNormal ) ) * 0.495 + 0.5;

  uv -= 0.5;
  uv.x *= -1.0;
  uv += 0.5;

  vec3 light3 = texture2D(uMatcap, uv).rgb;
  float matLight = light3.b;
  float noise_matLight = snoise4D(vec4(vPosition * 0.8, uTime * 0.025 + uRandom.x * 10.0)) * 0.5 + 0.5;

  matLight = mix(
    pow(matLight, 4.0), pow(matLight, 2.0), noise_matLight
  );

  float spotLight = 0.0;

  float noise = snoise4D(vec4(vPosition * 0.7, uTime * 0.1 + uRandom.y * 10.0)) * 0.5 + 0.5;
  vec3 color;

  // shield

  #if (CHECK == 1)
    // noise = cos(uTime * 0.1 + uRandom.x * 10.0) * 0.5 + 0.5;
    color = mix(uColor1, uColor2, noise);
    color = pow(color, vec3(0.1));
  #else
    color = mix(uColor1, uColor2, smoothstep(0.0, uColorMap.x, noise));
    color = mix(color, uColor3, smoothstep(uColorMap.x, uColorMap.z, noise));
    color = mix(color, uColor4, smoothstep(uColorMap.y, 1.0, noise));
  #endif
  // color = mix(vec3(0.0), color, light);


  float f2 = 1.0 - fresnelEffect(0.7);

  vec3 lightDir = uLightPos - vWorldPos;
  float l = length(lightDir);
  lightDir = normalize(lightDir);

  spotLight = clamp(dot(vNormal, lightDir), 0.0, 1.0);
  spotLight = (pow(spotLight, 3.0) * 0.2 + pow(spotLight, 10.0) * 0.1);

  #if (CHECK == 0)
  color = mix(color, uBgColor, smoothstep(0.5, 0.8, (vPosition.x - vPosition.y) * 0.5 + 0.49) * f2);
  color += smoothstep(0.2, 0.46, -vPosition.x + vPosition.y + vPosition.z * 3.0) * 0.8 * mix(0.5, 0.8, noise_matLight);
  #endif

  color = mix(color, pow(color, vec3(2.0)), light3.g);
  float f = fresnelEffect(1.5);
  f *= 1.2;

  color = mix(color, uLightColor, f);
  color = mix(color, vec3(1.0), smoothstep(0.0, 0.7, matLight));
  color *= 1.2;

  float alpha = 1.0;
  #if(CHECK == 0)
    alpha = smoothstep(0.9, 0.75, f);
  #else
    alpha = smoothstep(0.25, 0.15, f);
  #endif

  vec3 bgColorHSV = rgb2hsv(uBgColor);

  vec3 hsv = rgb2hsv(color);
  hsv.r = mix(bgColorHSV.r, hsv.r, uProgress.x);
  hsv.g = mix(mix(bgColorHSV.g, 0.0, light), hsv.g, uProgress.x);
  hsv.b = mix(mix(bgColorHSV.b, 1.0, light), hsv.b, uProgress.z);
  color = hsv2rgb(hsv);


  gl_FragColor = vec4(color, alpha);
}
`
